'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPanoramaVertical = function MdPanoramaVertical(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10.9 33.4h18.2c-1.3-4.3-1.9-8.9-1.9-13.4s0.6-9.1 1.9-13.4h-18.2c1.3 4.3 1.9 8.9 1.9 13.4s-0.6 9.1-1.9 13.4z m22.3 1.8c0.1 0.2 0.2 0.4 0.2 0.5 0 0.6-0.5 0.9-1.1 0.9h-24.6c-0.7 0-1.1-0.3-1.1-0.9 0-0.2 0.1-0.3 0.2-0.5 1.8-4.9 2.7-10 2.7-15.2s-0.9-10.3-2.7-15.2c-0.1-0.2-0.2-0.4-0.2-0.5 0-0.6 0.4-0.9 1.1-0.9h24.6c0.7 0 1.1 0.3 1.1 0.9 0 0.2-0.1 0.3-0.2 0.5-1.8 4.9-2.7 10-2.7 15.2s0.9 10.3 2.7 15.2z' })
        )
    );
};

exports.default = MdPanoramaVertical;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/panorama-vertical.js
// module id = 2610
// module chunks = 0